import React from 'react';
import {observer} from 'mobx-react';
import {APIProvider, Map, AdvancedMarker, Pin} from '@vis.gl/react-google-maps';
import {Modal, ModalButtons} from 'shared/components/modals';
import GoogleMapsApi from 'shared/components/google_location_picker/GoogleMapsApi';
import RadiusCircle from 'shared/components/google_location_picker/components/RadiusCircle';
import {FormattedMessage} from 'react-intl';

const LegendDot = ({color}) => (
  <span style={{height: 10, width: 10, minWidth: 10, backgroundColor: color, borderRadius: '50%', display: 'inline-block'}}/>
);

const Legend = () => {
  return (
    <div className='bg-white rounded box-shadow-1 px2 py1 absolute' style={{bottom: 12, left: 12}}>
      <div className='flex align-items-middle mb1'>
        <LegendDot color='#54C379'/>
        <span className='ml1 h6'><FormattedMessage id='time_tracking.timesheet.Work location'/></span>
      </div>
      <div className='flex align-items-middle'>
        <LegendDot color='#4A90E2'/>
        <span className='ml1 h6'><FormattedMessage id='time_tracking.timesheet.Employee location'/></span>
      </div>
    </div>
  );
};

const ClockInLocationModal = observer(({isOpen, uiState}) => {
  const {viewingClockEvent} = uiState;
  const {location, geofenceLocation} = viewingClockEvent;

  if (!location) return null;

  const center = geofenceLocation || location;

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => uiState.closeClockInLocationModal()}
      title={viewingClockEvent.isClockIn ? 'time_tracking.timesheet.Clock In Location' : 'time_tracking.timesheet.Clock Out Location'}
      size='md'
    >
      <APIProvider apiKey={GoogleMapsApi.API_KEY}>
        <div className='relative'>
          <Map
            mapId='clock-in-location-map'
            defaultCenter={{lat: center.latitude, lng: center.longitude}}
            defaultZoom={15}
            style={{height: '400px'}}
            gestureHandling='greedy'
            streetViewControl={false}
            fullscreenControl={false}
            mapTypeControl={false}
          >
            {geofenceLocation && <RadiusCircle
              coords={{lat: geofenceLocation.latitude, lng: geofenceLocation.longitude}}
              radius={250}
              fillColor='#54C379'
              strokeColor='#54C379'
            />}
            <RadiusCircle
              coords={{lat: location.latitude, lng: location.longitude}}
              radius={location.accuracy}
              fillColor='#4A90E2'
              strokeColor='#4A90E2'
            />
            {geofenceLocation && <AdvancedMarker position={{lat: geofenceLocation.latitude, lng: geofenceLocation.longitude}}>
              <Pin background='#54C379' borderColor='#3AA65E' glyphColor='#3AA65E'/>
            </AdvancedMarker>}
            <AdvancedMarker position={{lat: location.latitude, lng: location.longitude}}>
              <Pin background='#4A90E2' borderColor='#2275D3' glyphColor='#2275D3'/>
            </AdvancedMarker>
          </Map>
          {geofenceLocation && <Legend/>}
        </div>
      </APIProvider>
      <ModalButtons
        hideSave={true}
        cancelCaption='time_tracking.timesheet.Close'
        onCancel={() => uiState.closeClockInLocationModal()}
      />
    </Modal>
  );
});

export default ClockInLocationModal;
